import { render } from "./Chapter14.vue?vue&type=template&id=60fb1066&scoped=true"
import script from "./Chapter14.vue?vue&type=script&lang=js"
export * from "./Chapter14.vue?vue&type=script&lang=js"

import "./Chapter14.vue?vue&type=style&index=0&id=60fb1066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fb1066"]])

export default __exports__